import React from "react";
import { QRCode } from "react-qrcode-logo";

const CardQR = ({
  colorFirst,
  colorSecond,
  imageSourceProfile,
  maximize,
  firstName,
  middleName,
  lastName,
  jobTitle,
  company,
  aboutMe,
  prefix,
  suffix,
  slug,
}) => {
  const calculateQRSize = () => {
    const oneVhInPx = window.innerHeight / 100;
    return oneVhInPx;
  };
  return (
    <div className="flex flex-col w-full flex-1" id="qrBusiness">
      <div
        className={`flex flex-col w-full items-start ${
          maximize
            ? "h-[75vh] shadow-[0px_25px_25px_rgba(122,122,122,0.5),0px_-5px_6px_rgba(122,122,122,0.2)]"
            : "max-h-[70vh] shadow-xl"
        } overflow-y-auto justify-between items-center py-20 scrollbar-hide`}
        style={{
          backgroundColor: colorFirst,
        }}
      >
        <div className="flex flex-col justify-start items-center">
          <img
            src={imageSourceProfile}
            className="flex flex-col h-[130px] w-[130px] bg-gray-200 border-white border-4 rounded-full"
          />
          <div
            className="flex flex-col w-full px-5 justify-center-center gap-4 divide-y-2 mt-5 text-center"
            style={{
              color: colorSecond,
            }}
          >
            {firstName ||
            middleName ||
            lastName ||
            jobTitle ||
            company ||
            aboutMe ? (
              <div className="flex flex-col w-full items-center">
                {firstName || middleName || lastName ? (
                  <div className="text-[22px] font-bold">
                    {(prefix || "") +
                      " " +
                      (firstName || "") +
                      " " +
                      (middleName || "") +
                      " " +
                      (lastName || "") +
                      " " +
                      (suffix || "")}
                  </div>
                ) : null}
                {jobTitle || company ? (
                  <div className="text-[14px]">
                    {jobTitle ? jobTitle : "Job Title"}
                    {company ? " at " + company || "" : ""}
                  </div>
                ) : null}
              </div>
            ) : null}{" "}
          </div>
        </div>

        <QRCode
          id={"qr"}
          value={"https://app.nitomeyocard.com/me/" + slug}
          size={250}
          qrStyle={"dots"}
          logoOpacity={0.15}
          bgColor={"transparent"}
          level={"H"}
          fgColor={colorSecond}
        />
      </div>
    </div>
  );
};

export default CardQR;
